
// Production configuration
export const APP_CONFIG = {
  PRODUCTION_DOMAIN: 'https://resonow.org',
  SITE_NAME: 'Resonow',
  SUPPORT_EMAIL: 'info@resonow.org',
  LOGO_URL: 'https://resonow.org/logo.png'
} as const;
